export default __webpack_public_path__ + "static/media/bowlingimg.986c3cdb.png";